import { render, staticRenderFns } from "./TermsOfUse.vue?vue&type=template&id=d4ed833a&scoped=true&"
import script from "./TermsOfUse.vue?vue&type=script&lang=js&"
export * from "./TermsOfUse.vue?vue&type=script&lang=js&"
import style0 from "./TermsOfUse.vue?vue&type=style&index=0&id=d4ed833a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4ed833a",
  null
  
)

export default component.exports